var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.25 2.12451C10.0074 2.12451 9 3.13187 9 4.37451V6.10927C9.76128 6.48704 10.2493 7.26589 10.2493 8.12451V9.87451L11.75 9.87451C12.9926 9.87451 14 10.8819 14 12.1245C14 13.3672 12.9926 14.3745 11.75 14.3745H10.2493V16.1245C10.2493 16.9831 9.76128 17.762 9 18.1397V19.8745C9 21.1172 10.0074 22.1245 11.25 22.1245H17.25C18.4926 22.1245 19.5 21.1172 19.5 19.8745V4.37451C19.5 3.13187 18.4926 2.12451 17.25 2.12451H11.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28618 7.43158C8.5665 7.54764 8.74928 7.82114 8.74928 8.12453L8.74928 11.3745L11.75 11.3745C12.1642 11.3745 12.5 11.7103 12.5 12.1245C12.5 12.5387 12.1642 12.8745 11.75 12.8745L8.74928 12.8745V16.1245C8.74928 16.4279 8.56649 16.7014 8.28617 16.8175C8.00585 16.9335 7.68322 16.8693 7.46877 16.6547L3.50385 12.687C3.34818 12.5496 3.25 12.3485 3.25 12.1245C3.25 11.9016 3.34723 11.7015 3.50159 11.5641L7.46878 7.59437C7.68324 7.37977 8.00587 7.31552 8.28618 7.43158Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoLogOut);
export default __webpack_public_path__ + "static/media/DuoLogOut.ee20c7578b0d25e5ee6652a12dc0d1a8.svg";
export { ForwardRef as ReactComponent };